import React from 'react'
import { IonContent, IonPage } from '@ionic/react'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useDispatch, useSelector } from 'react-redux'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import BillingMobile from '../billingContentMobile/BillingMobile.component'
import BillingTablet from '../billingContentTablet/BillingTablet.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { setSelectedOption } from '../store/billing.actions'
import { BillingConstants } from '../store/billing.constants'
import {
  hasUnsavedInsuranceData,
  hasUnsavedRandGData,
  showUnsavedDataWarningMessage,
} from '../../../utilities/unSavedData.util'
import { IInsuranceInformationState } from '../../insuranceInformation/store/insuranceInformation.types'
import { getRelationshipsAndGuarantors } from '../../relationshipsAndGuarantors/selectors/getRelationshipsAndGuarantors.selector'
import { getInsuranceInformationStateSelector } from '../../insuranceInformation/selectors/insuranceInformationState.selector'
import { IRelationshipsAndGuarantorsState } from '../../relationshipsAndGuarantors/store/relationshipsAndGuarantors.types'
import { clearInsuranceInformationData } from '../../insuranceInformation/store/insuranceInformation.actions'
import { clearRelationshipsAndGuarantorsData } from '../../relationshipsAndGuarantors/store/relationshipsAndGuarantors.action'
import { RelationshipsAndGuarantorsConstants } from '../../relationshipsAndGuarantors/store/relationshipsAndGuarantors.constants'
import ValidationService from '../../validation/services/validation.services'

const Billing: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { isTablet } = useDeviceMetrics()
  const { relationshipsAndGuarantorsData, relationshipsAndGuarantorsList }: IRelationshipsAndGuarantorsState =
    useSelector(getRelationshipsAndGuarantors)
  const { insuranceInformationData, insuranceInformationList }: IInsuranceInformationState = useSelector(
    getInsuranceInformationStateSelector
  )

  const onBackClickYes = () => {
    history.push(TabConstants.CHART_ROUTE)
    dispatch(setSelectedOption(BillingConstants.INSURANCE_INFORMATION_OPTION))
    dispatch(clearInsuranceInformationData())
    if (hasUnsavedRandGData(relationshipsAndGuarantorsData, relationshipsAndGuarantorsList)) {
      dispatch(clearRelationshipsAndGuarantorsData())
    }
    ValidationService.clearValidation(RelationshipsAndGuarantorsConstants.SET_DOB)
    ValidationService.clearValidation(RelationshipsAndGuarantorsConstants.SET_AGE)
    ValidationService.clearValidation(RelationshipsAndGuarantorsConstants.SET_SSN)
  }

  const onBackClick = () => {
    if (hasUnsavedRandGData(relationshipsAndGuarantorsData, relationshipsAndGuarantorsList)) {
      showUnsavedDataWarningMessage(
        dispatch,
        t,
        t('relationshipsAndGuarantors.unsavedDataWarningMessage'),
        onBackClickYes
      )
      return
    }
    if (hasUnsavedInsuranceData(insuranceInformationData, insuranceInformationList)) {
      showUnsavedDataWarningMessage(dispatch, t, t('insuranceInformation.unsavedDataWarningMessage'), onBackClickYes)
      return
    }
    onBackClickYes()
  }

  return (
    <IonPage id='BillingPage'>
      <PCRHeader />
      <HeaderNav prevOnClick={onBackClick} prevLabel={t('common.buttons.Back')} title='Billing' isBackButton={true} />
      <IonContent color='light'>
        {isTablet && <BillingTablet />}
        {!isTablet && <BillingMobile />}
      </IonContent>
    </IonPage>
  )
}

export default Billing
